// extracted by mini-css-extract-plugin
module.exports = {"container":"AnteprimaNotifiche_container__2zKUk","linkbutton":"AnteprimaNotifiche_linkbutton__3Kn7O","boxinfo":"AnteprimaNotifiche_boxinfo__2EVc0"};